import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const NewNotificationBell = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon {...rest} viewBox="0 0 25 25">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7017 17C18.6927 17 19.4969 16.2055 19.5 15.2234C19.4994 14.7237 19.2981 14.2448 18.9406 13.8923L17.7491 12.7104V9.19944C17.7488 7.8194 17.1951 6.49606 16.2099 5.52084C15.2246 4.54562 13.8887 3.99851 12.4962 4C9.59977 4.00156 7.25241 6.32882 7.25189 9.19944V12.7076L6.0603 13.8895C5.70257 14.2419 5.50098 14.7208 5.5 15.2206C5.50313 16.2027 6.30733 16.9972 7.29827 16.9972L17.7017 17Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 20.5002H14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

NewNotificationBell.propTypes = {
  color: PropTypes.string
};

NewNotificationBell.defaultProps = {
  color: 'var(--color-base-fill)'
};

export default NewNotificationBell;
